import React, { Component, PropTypes } from 'react';
import IconControl from 'components/IconControl';
import ButtonControl from 'components/ButtonControl';
import PureRenderMixin from 'react-addons-pure-render-mixin';

import './MobileBackButton.scss';

class MobileBackButton extends Component {

    static propTypes = {
        address: PropTypes.string,
        label: PropTypes.string,
        onClick: PropTypes.func,
    };

    _onClick = () => {
        var stage = this.props.address;

        if (this.props.onClick) {
            this.props.onClick(stage);
        }
    };

    static defaultProps = {
        address: `/`,
        label: 'Назад',
    };

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {

        return (
            <div className="MobileBackButton">
                <ButtonControl className="MobileBackButton-back"
                    view="backLink"
                    address={this.props.address}
                    leftIcon={<IconControl className="MobileBackButton-icon" name="leftArrow"/>}
                    onClick={this._onClick}>
                    {this.props.label}
                </ButtonControl>
            </div>
        );
    }
}

export default MobileBackButton;



// WEBPACK FOOTER //
// ./client/components/MobileBackButton/MobileBackButton.js